module.exports = __webpack_public_path__ + "img/Telekom.0ec3fbfe.svg";